import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { PersistentInvitePeopleButton } from '@confluence/persistent-invite-button';
import { fg } from '@confluence/feature-gating';

import { NAV_COLLAPSE_BREAKPOINT_PX } from '../layoutConstants';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const PersistentInvitePeopleButtonLayout = styled.div<{
	rightSidebarCompensation: number;
}>`
	margin-top: auto;
	.persistent-invite-button-container {
		margin-bottom: ${token('space.400', '32px')};
	}
	.persistent-invite-icon-button {
		display: none;
		padding: ${token('space.050', '4px')};
		width: 100%;
	}
	.persistent-invite-button {
		display: block;
		padding: 0px;
	}
	@media (max-width: ${({ rightSidebarCompensation }) =>
			NAV_COLLAPSE_BREAKPOINT_PX + rightSidebarCompensation}px) {
		.persistent-invite-icon-button {
			display: block;
		}
		.persistent-invite-button {
			display: none;
		}
	}
`;

const persistentInvitePeopleButtonLayoutStyles = css({
	marginTop: 'auto',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.persistent-invite-button-container': {
		marginBottom: token('space.400', '32px'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.persistent-invite-icon-button': {
		display: 'none',
		padding: token('space.050', '4px'),
		width: '100%',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.persistent-invite-button': {
		display: 'block',
		padding: '0px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	[`@media (max-width: var(--media-max-width)px)`]: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'.persistent-invite-icon-button': {
			display: 'block',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'.persistent-invite-button': {
			display: 'none',
		},
	},
});

export function PersistentInvitePeopleButtonContainer({
	rightSidebarCompensation,
}: {
	rightSidebarCompensation: number;
}) {
	if (fg('confluence_frontend_home_compiled_migration')) {
		return (
			<div
				css={persistentInvitePeopleButtonLayoutStyles}
				style={
					{
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
						'--media-max-width': `${NAV_COLLAPSE_BREAKPOINT_PX + rightSidebarCompensation}px`,
					} as React.CSSProperties
				}
			>
				<PersistentInvitePeopleButton source="homeScreen" hasIconButton />
			</div>
		);
	}
	return (
		<PersistentInvitePeopleButtonLayout rightSidebarCompensation={rightSidebarCompensation}>
			<PersistentInvitePeopleButton source="homeScreen" hasIconButton />
		</PersistentInvitePeopleButtonLayout>
	);
}
